<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-5-65-million-years-ago">
<h1>Chapter 5<br/> 65 Million Years Ago</h1>
<p>Bjorn and Zorn travel 65 million years into the Earth’s past and arrive just before the comet strike that wiped out the dinosaur population. Ptoni, a Pteranodon, in what is now known as Kansas, is sitting on a large rock enjoying a big, juicy fish. Suddenly, he hears and feels a loud rumble. Looking up, he can see an asteroid hurtling towards him. All of his dinosaur friends scatter and run away in panic. Fortunately for Ptoni, the asteroid strike is hundreds of kilometres away. The impact causes a huge BANG, and the ground under his rock shakes. Ptoni, now very frightened, drops his fish and attempts to fly away. Just as he lifts off, he disappears into thin air. Ptoni re-materialises on the spaceship with Bjorn and Zorn.</p>
<p>“Krelbo?” says Bjorn to Ptoni.</p>
<p>Ptoni has never heard speech before. It is puzzling.</p>
<p>Zorn tries. “Krelbo?”</p>
<p>Ptoni continues to look puzzled. Bjorn and Zorn are shapeshifters, and change form to become pteranodons, identical to Ptoni. They squawk back and forth to Ptoni, and to each other, but Ptoni doesn’t respond. Bjorn and Zorn, pausing, look at each other, and change into human form.</p>
<p>“I don’t understand,” says Bjorn.</p>
<p>“Maybe this creature can’t communicate in the same way that we do,” suggests Zorn.</p>
<p>Speaking to Ptoni, Bjorn asks, “What’s your name?” Ptoni continues to sit still and do nothing.</p>
<p>Zorn, picking up a scanning device, points it at Ptoni, scanning him inside and out.</p>
<p>Looking down at the screen, he says, “Here’s the problem. Tiny brain. No speech centres.”</p>
<p>“Easily fixed,” says Bjorn.</p>
<p>Bjorn creates a golden ball of light out of thin air with his hands. The ball, moving under its own power, enters Ptoni’s head, and he speaks.</p>
<p>“I am Ptoni, the pteranodon—”</p>
<p>He stops mid-sentence, putting his wing over his mouth as if he is trying to stop the noise coming out.</p>
<p>“What have you done to me? Why am I making these strange noises?”</p>
<p>Ptoni passes out.</p>
<p>Bjorn , leaning over Ptoni, says, “Well, that’s a new one.”</p>
<p>Bjorn groans.</p>
<p>The ever-calm Zorn says, “Just let him sleep it off.”</p>
<p>“OK, let’s get back to 2035. We can find more help there,” suggests Bjorn.</p>
<p>“On it,” says Zorn. He warps the ship back to 2035.</p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?282ec410